import React from 'react'
import MetricCard from '../MetricCard'
import { Activity, CircleDashed, Gem, PackageSearch, ShieldAlert } from 'lucide-react'

const DealSummary = ({statsDealsCampaigns}) => {
  const cardDetails = [
    {
      icon: <PackageSearch size={24} />,
      title: "Deals Posted",
      value: statsDealsCampaigns?.total_deals || 0,
      change: "10",
      period: "this week"
    },
    // {
    //   icon: <Activity size={24} />,
    //   title: "Campaigns",
    //   value: statsDealsCampaigns?.total_campaigns || 0,
    //   change: "10",
    //   period: "this week"
    // },
    {
      icon: <ShieldAlert size={24} />,
      title: "Wishlisted Deals",
      value: statsDealsCampaigns?.total_wishlisted_deals || 0,
      change: "10",
      period: "this week"
    },
    {
      icon:<CircleDashed size={24} />,
      title: "Pending Redemptions",
      value: statsDealsCampaigns?.total_redeemed_deals || 0,
      change: "10",
      period: "this week"
    },
    {
      icon: <Gem size={24} />,
      title: "Redeemed Deals",
      value: statsDealsCampaigns?.total_completed_deals || 0,
      change: "10",
      period: "this week"
    }
  ]
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {
        cardDetails.map((card, index) => (
          <MetricCard key={index} {...card} />
        ))
      }
    </div>
  )
}

export default DealSummary